/**
 * Shared TanStack Query client (CLAUDE.md F6 — server state lives here, never in
 * Zustand/Context). Tune per-query options at the call site; these are defaults.
 */
import { QueryClient } from '@tanstack/react-query';

import type { ApiError } from './types';

/** Don't retry client errors (4xx) — only transient network/5xx failures. */
function shouldRetry(failureCount: number, error: unknown): boolean {
  const status = (error as ApiError)?.status;
  if (typeof status === 'number' && status >= 400 && status < 500) return false;
  return failureCount < 3;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // treat data as fresh for 30s
      gcTime: 5 * 60_000, // keep unused cache for 5min
      retry: shouldRetry,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
